<template>
    <Card>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.from_date')">
                        <DatePicker v-model="filters.date.from"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.to_date')">
                        <DatePicker v-model="filters.date.to"/>
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.products')">
                        <Autocomplete
                            url="/catalog/product-items"
                            :model-value="filters.products?.[0]?.uuid"
                            :selected-value="filters.products?.[0]?.name"
                            :can-be-empty="true"
                            @update:model-value="filters.products = $event !== null ? [$event] : []"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.warehouses')">
                        <Autocomplete
                            url="/management/warehouses"
                            :model-value="filters.warehouses?.[0]?.uuid"
                            :selected-value="filters.warehouses?.[0]?.name"
                            :can-be-empty="true"
                            @update:model-value="filters.warehouses = $event !== null ? [$event] : []"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <FetchTable
            :handle="tableHandle"
            url="/analytics/turnover"
            v-model:orders="table.orders"
            :columns="table.columns"
        >
            <template #card-body-actions>
                <div class="row" style="width: 1000px">
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.from_date')" class="mb-0">
                            <DatePicker v-model="filters.date.from"/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.to_date')" class="mb-0">
                            <DatePicker v-model="filters.date.to"/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.products')" class="mb-0">
                            <Autocomplete
                                url="/catalog/product-items"
                                :model-value="filters.products?.[0]?.uuid"
                                :selected-value="filters.products?.[0]?.name"
                                :can-be-empty="true"
                                @update:model-value="filters.products = $event !== null ? [$event] : []"
                            />
                        </FormGroup>
                    </div>
                    <div class="col-lg-3">
                        <FormGroup :label="$t('labels.warehouses')" class="mb-0">
                            <Autocomplete
                                url="/management/warehouses"
                                :model-value="filters.warehouses?.[0]?.uuid"
                                :selected-value="filters.warehouses?.[0]?.name"
                                :can-be-empty="true"
                                @update:model-value="filters.warehouses = $event !== null ? [$event] : []"
                            />
                        </FormGroup>
                    </div>
                </div>
            </template>
            <template #td-productImage="{row}">
                <ImageZoomComponent
                    :url="row.fileUrl !== null ? row.fileUrl : PLACEHOLDER_IMAGE_URL"
                    :alt="row.productName"
                    :default-width="50"
                    :default-height="50"
                />
            </template>
            <template #td-productName="{row}">
                <router-link
                    v-if="row.productUuid"
                    class="long-string"
                    :to="{ name: 'EditProductPage', params: { productUuid: row.productUuid } }"
                    :title="row.productName"
                >
                    {{ row.productName.length > 70 ? row.productName.substring(0, 70) + '...' : row.productName }}
                </router-link>
                <span v-else class="long-string" :title="row.productName">
                    {{ row.productName.length > 70 ? row.productName.substring(0, 70) + '...' : row.productName }}
                </span>
                <slot v-if="row.productSku">
                    <span class="text-muted">{{ row.productSku }}</span>
                </slot>
            </template>
            <template #td-warehouseName="{row}">
                <router-link
                    :to="{ name: 'EditWarehousePage', params: { warehouseUuid: row.warehouseUuid } }"
                    :style="['white-space: nowrap']"
                    :title="row.warehouseName"
                >
                    {{ row.warehouseName }}
                </router-link>
            </template>
            <template #td-previousBalance="{row}">
                {{ Amount.factory(row.previousBalance).toMeasurementString(row.measurement) }}
            </template>
            <template #td-arrived="{row}">
                {{ Amount.factory(row.arrived).toMeasurementString(row.measurement) }}
            </template>
            <template #td-exited="{row}">
                {{ Amount.factory(row.exited).toMeasurementString(row.measurement) }}
            </template>
            <template #td-balance="{row}">
                {{ Amount.factory(row.balance).toMeasurementString(row.measurement) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import DatePicker from '../../../../components/new/form/datePiker/DatePicker.vue';
import FormGroup from '../../../../components/new/form/group/FormGroup.vue';
import Autocomplete from '../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import FetchTable from '../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../components/new/table/tableHandle';
import ImageZoomComponent from '../../../../components/new/image/ImageZoomComponent.vue';
import Amount from '../../../../services/Amount';
import { PLACEHOLDER_IMAGE_URL } from '../../../constants';
export default {
    name: "TurnoverIndexPage",
    components: {
        DatePicker, FormGroup, Autocomplete, FetchTable, ImageZoomComponent, Card
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            Amount,
            PLACEHOLDER_IMAGE_URL,
            table: {
                orders: [],
                columns: [
                    {key: "warehouseName", name: this.$t('labels.turnover_page.warehouse_name'), width: "200px", type: "string", order: true},
                    {key: "productImage", name: this.$t('labels.turnover_page.product_image'), width: "150px", type: "string", order: false},
                    {key: "productName", name: this.$t('labels.turnover_page.product_name'), width: "auto", type: "string", order: true},
                    {key: "previousBalance", name: this.$t('labels.turnover_page.previous_balance'), width: "150px", type: "string", order: true},
                    {key: "arrived", name: this.$t('labels.turnover_page.arrived'), width: "150px", type: "string", order: true},
                    {key: "exited", name: this.$t('labels.turnover_page.exited'), width: "150px", type: "string", order: true},
                    {key: "balance", name: this.$t('labels.turnover_page.balance'), width: "150px", type: "string", order: true},
                    {key: "turnover", name: this.$t('labels.turnover_page.turnover_period'), width: "150px", type: "string", order: true},
                    {key: "days", name: this.$t('labels.turnover_page.days'), width: "150px", type: "string", order: true},
                ]
            },
            filters: {
                date: {
                    from: new Date(new Date() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
                    to: new Date().toISOString().split('T')[0]
                },
                products: [],
                warehouses: []
            },
        }
    },
    methods: {
        refreshTable() {
            this.tableHandle.page = 1
            this.tableHandle.fetchRows({
                dateFrom: this.filters.date.from,
                dateTo: this.filters.date.to,
                productUuids: this.filters.products.map(product => product.uuid),
                warehouseUuids: this.filters.warehouses.map(warehouse => warehouse.uuid)
            })
        }
    },
    watch: {
        filters: {
            handler: function () {
                this.refreshTable()
            },
            deep: true
        }
    },
    mounted() {
        this.refreshTable()
    },
}
</script>
<style scoped>
.long-string {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
</style>
